var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{staticClass:"dropdown-submenu",class:_vm.visibilityClass,on:{"toggle":_vm.toggle}},[_c('template',{slot:"button-content"},[_vm._t("button-content")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }